import * as React from 'react';
import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ActionButtonSizes } from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import {
  Div,
  LoadingContainer,
  PointsWrapper,
  RewardsText,
  StyledActionButton,
  StyledPoints,
  StyledPointsIcon,
  StyledRewardsCarousel,
  Wrapper,
} from './loyalty-points-rewards-widget.styled';
import useHomeRewards from './use-home-rewards';

const LoyaltyPointsAndRewardsWidget = () => {
  const { formatMessage } = useIntl();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const { rewards, loadingRewards } = useHomeRewards();
  const userPoints = loyaltyUser?.points ?? 0;

  const rewardsMessage = useMemo(() => {
    if (!rewards?.length) {
      return '';
    }

    let messageId = 'loyaltyUseYourPoints';
    let points: number | undefined;

    const nextReward = rewards.find(({ locked, pointCost }) => locked && pointCost > userPoints);

    if (nextReward) {
      messageId = 'loyaltyEarnMorePointsForReward';
      points = nextReward.pointCost - userPoints;
    }

    return formatMessage({ id: messageId }, { points });
  }, [formatMessage, rewards, userPoints]);

  const loading = (loyaltyLoading || loadingRewards) && !!rewardsMessage;

  return (
    <Wrapper data-testid="reward-widget">
      {loading ? (
        <LoadingContainer data-testid="widget-loader">
          <LoadingAnimation fillColor={Styles.color.primary} />
        </LoadingContainer>
      ) : (
        <>
          <Div>
            <PointsWrapper>
              <StyledPoints data-testid="user-points">{userPoints}</StyledPoints>
              <StyledPointsIcon />
            </PointsWrapper>

            <RewardsText data-testid="rewards-message">{rewardsMessage}</RewardsText>

            <StyledActionButton
              size={ActionButtonSizes.SMALL}
              to={`${formatMessage({ id: 'routes.loyaltyHome' })}/list`}
            >
              {formatMessage({ id: 'loyaltyUseMyCrowns' })}
            </StyledActionButton>
          </Div>
          {!!rewards.length && <StyledRewardsCarousel rewards={rewards} />}
        </>
      )}
    </Wrapper>
  );
};

export default LoyaltyPointsAndRewardsWidget;
